import { getCollapsiblePanelStyles, getStepStyles } from '../../shared/styles';

export const getStyles = (components, theme) => ({
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
  adGroupSettingsStep: {
    ...getStepStyles(),
  },
});
